.ico-button {
  @apply w-full inline-flex outline-none box-border cursor-pointer;
  @apply items-center justify-center text-center no-underline text-lg whitespace-nowrap;
  @apply border-2 border-solid;
  @apply active:shadow-button hover:shadow-button-drop focus:shadow-button-drop;
  @apply transition duration-300;
  @apply px-8;

  font-family: var(--typography-font-button);
  border-radius: var(--border-radius-button);
}

.ico-button--disabled {
  @apply opacity-30 pointer-events-none select-none;
}

/* Styles */

.ico-button--primary {
  background-color: var(--clrs-bg-button-primary);
  border-color: var(--clrs-border-button-primary);
  color: var(--clrs-text-button-primary);
  font-weight: var(--font-weight-button-primary);
}

.ico-button--primary:hover {
  background-color: var(--clrs-bg-button-primary-hover);
  border-color: var(--clrs-border-button-primary-hover);
  color: var(--clrs-text-button-primary-hover);
}

.ico-button--secondary {
  background-color: var(--clrs-bg-button-secondary);
  border-color: var(--clrs-border-button-secondary);
  color: var(--clrs-text-button-secondary);
  font-weight: var(--font-weight-button-secondary);
}

.ico-button--secondary:hover {
  background-color: var(--clrs-bg-button-secondary-hover);
  border-color: var(--clrs-border-button-secondary-hover);
  color: var(--clrs-text-button-secondary-hover);
}

.ico-button--tertiary {
  background-color: var(--clrs-bg-button-tertiary);
  border-color: var(--clrs-border-button-tertiary);
  color: var(--clrs-text-button-tertiary);
  font-weight: var(--font-weight-button-tertiary);
}

.ico-button--tertiary:hover {
  background-color: var(--clrs-bg-button-tertiary-hover);
  border-color: var(--clrs-border-button-tertiary-hover);
  color: var(--clrs-text-button-tertiary-hover);
}

.ico-button--tertiary-secondary {
  background-color: var(--clrs-bg-button-tertiary-secondary);
  border-color: var(--clrs-border-button-tertiary-secondary);
  color: var(--clrs-text-button-tertiary-secondary);
  font-weight: var(--font-weight-button-tertiary);
}

.ico-button--next-navigation {
  background-color: var(--clrs-bg-button-navigation-next);
  border-color: var(--clrs-border-button-navigation-next);
  color: var(--clrs-text-button-navigation-next);
  font-weight: var(--font-weight-button-primary);
}

.ico-button--back-navigation {
  background-color: var(--clrs-bg-button-navigation-back);
  border-color: var(--clrs-border-button-navigation-back);
  color: var(--clrs-text-button-navigation-back);
  font-weight: var(--font-weight-button-primary);
}

.ico-button--final-action {
  background-color: var(--clrs-bg-button-final-action);
  border-color: var(--clrs-border-button-final-action);
  color: var(--clrs-text-button-final-action);
  font-weight: var(--font-weight-button-primary);
}

/* Sizes */

.ico-button--narrow {
  @apply px-3;
}
.ico-button--xlarge {
  @apply h-14;
}
.ico-button--large {
  @apply h-12;
}

.ico-button--xmedium {
  @apply h-9.5;
  @apply text-base;
}

.ico-button--medium {
  @apply h-8;
}

.ico-button--small {
  @apply h-6;
}

.ico-button--xsmall {
  @apply h-9.5;
  @apply text-base;
  @apply px-3.5;
}
